module.exports = __webpack_public_path__ + "img/ic_property_detachedbungalow.171d55ee.svg";